import Marionette from "backbone.marionette";
import Radio from "backbone.radio";
import ChartEditMetaView from "../meta";
import DRGAddForm from "./form-simple";
import AnalyticsBehavior from "../../../behaviors/analytics";
import templates from "../../../utils/templates";

const channel = Radio.channel("global");

const DEFAULTS = {
  template: templates.find("chart_reviews", "chart_edit_drg_add"),
};

class View extends Marionette.LayoutView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  behaviors() {
    return [
      {
        behaviorClass: AnalyticsBehavior,
        opts: {
          fireOnRender: false,
          title: this.options.title || null,
        },
      },
    ];
  }

  regions() {
    return {
      meta: ".chart-review-meta",
      form: ".drg-add-form",
    };
  }

  initialize() {
    this.listenTo(channel, "tab-activated", this._onActivate);
  }

  onBeforeShow() {
    this.meta.show(
      new ChartEditMetaView({
        model: this.model,
        memberCategories: this.model.get("memberCategories"),
      })
    );

    this.form.show(
      new DRGAddForm({
        model: this.model,
      })
    );
  }

  _onActivate(tab) {
    if ("tab-drg-add" === tab) {
      // notify behaviors
      this.triggerMethod("Activation");
    }
  }
}

export { View as default };
